import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PopoverService {
  private closeAllSubject = new Subject<string>()
  closeAll$ = this.closeAllSubject.asObservable()

  /**
   * Request to close all popovers except the one with the given id
   * @param exceptId The id of the popover to keep open
   */
  closeAllExcept(exceptId: string) {
    this.closeAllSubject.next(exceptId)
  }
}
